"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudSettings = void 0;
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
const axios_1 = __importDefault(require("axios"));
/**
 * This class holds data for all cloud instances, and returns the specific data instance by parsing the dns suffix from a URL
 */
class CloudSettings {
    constructor() {
        this.METADATA_ENDPOINT = "/v1/rest/auth/metadata";
        this.defaultCloudInfo = {
            LoginEndpoint: process.env.AadAuthorityUri || "https://login.microsoftonline.com",
            LoginMfaRequired: false,
            KustoClientAppId: "db662dc1-0cfe-4e1c-a843-19a68e65be58",
            KustoClientRedirectUri: "https://microsoft/kustoclient",
            KustoServiceResourceId: "https://kusto.kusto.windows.net",
            FirstPartyAuthorityUrl: "https://login.microsoftonline.com/f8cdef31-a31e-4b4a-93e4-5f571e91255a",
        };
        this.cloudCache = {};
    }
    static getInstance() {
        if (!CloudSettings.instance) {
            CloudSettings.instance = new CloudSettings();
        }
        return CloudSettings.instance;
    }
    getCloudInfoForCluster(kustoUri) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (kustoUri in this.cloudCache) {
                return this.cloudCache[kustoUri];
            }
            try {
                const response = yield axios_1.default.get(kustoUri + this.METADATA_ENDPOINT);
                if (response.status == 200) {
                    this.cloudCache[kustoUri] = response.data.AzureAD || this.defaultCloudInfo;
                }
                else {
                    throw new Error(`Kusto returned an invalid cloud metadata response - ${response}`);
                }
            }
            catch (ex) {
                if (((_a = ex.response) === null || _a === void 0 ? void 0 : _a.status) == 404) {
                    // For now as long not all proxies implement the metadata endpoint, if no endpoint exists return public cloud data
                    this.cloudCache[kustoUri] = this.defaultCloudInfo;
                }
                else {
                    throw new Error(`Failed to get cloud info for cluster ${kustoUri} - ${ex}`);
                }
            }
            return this.cloudCache[kustoUri];
        });
    }
    static getAuthorityUri(cloudInfo, authorityId) {
        return cloudInfo.LoginEndpoint + "/" + (authorityId || "organizations");
    }
}
exports.CloudSettings = CloudSettings;
//# sourceMappingURL=cloudSettings.js.map